import { Article } from "@/graphql/gql/graphql";
import ArticleCard from "../articleCard";
import ErrorComponent from "../empty/ErrorComponent";
import styles from "./authorArticles.module.scss";

type AuthorArticlesProps = {
  articles: Article[];
};

const AuthorArticles = ({ articles }: AuthorArticlesProps) => {
  if (!articles || articles.length === 0) {
    return <ErrorComponent headline="Aaand... no good!" showCta={false} />;
  }
  return (
    <div className={styles.articles}>
      {articles?.map((article) => (
        <ArticleCard
          key={article.id}
          author={article.author}
          image={article.hero?.imageUrl?.url}
          link={`/${article.slug}`}
          origin="related_articles"
          publishedOn={article.firstPublishedAt}
          sportName={article.sport.name}
          sportSlug={article.sport.slug}
          title={article.title}
          description={article.description}
          displayHorizontal
          hasPadding={false}
          showAuthor={false}
        />
      ))}
    </div>
  );
};

export default AuthorArticles;
